import { render, staticRenderFns } from "./personalPaper.vue?vue&type=template&id=0c84ea0b"
import script from "./personalPaper.vue?vue&type=script&lang=js"
export * from "./personalPaper.vue?vue&type=script&lang=js"
import style0 from "./personalPaper.vue?vue&type=style&index=0&id=0c84ea0b&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports